import { FETCH_FAVOURITES, ADD_FAVOURITES, REMOVE_FAVOURITES } from '../actions/types';

export default function reducerFavourites(state = {}, action) {
	switch (action.type) {
		case FETCH_FAVOURITES:
			return action.payload;
		case ADD_FAVOURITES:
			return state.concat([action.payload]);
		case REMOVE_FAVOURITES:
			return [
					...state.slice(0, action.payload),
					...state.slice(action.payload + 1)
			];
		default:
			return state;
	}
}
